import ButtonBase from '@material-ui/core/ButtonBase'
import { withStyles } from '@material-ui/core/styles'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'
import Info from '@material-ui/icons/Info'
import cn from 'classnames'
import React from 'react'
import styled from 'styled-components'

import { SORT_TYPE } from '../../constants/commonConstants'

import Tooltip from '../Tooltip'
import { Text } from '../Typography'

const styles = theme => ({
  'sortable-header': {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  th: {
    color: `var(--gameday-table-tableHeaderTextColor, ${theme.table.tableHeaderTextColor})`,
    backgroundColor: `var(--gameday-table-tableHeaderBgColor, ${theme.table.tableHeaderBgColor})`,
    fontWeight: theme.typography.fontWeightBolder,
    padding: '6px 9px 5px',
    '&:first-child': {
      borderRadius: '4px 0 0 4px',
    },
    '&:last-child': {
      borderRadius: '0 4px 4px 0',
    },
    '&.align-center': {
      '& > div': {
        justifyContent: 'center',
      },
    },
    '&.align-right': {
      textAlign: 'right',
      '& > div': {
        justifyContent: 'flex-end',
      },
    },
    '&.full-width': {
      width: '100%',
    },
    '& label': {
      whiteSpace: 'nowrap',
    },
  },
  required: {
    color: theme.status.errorColor,
    paddingLeft: '4px',
  },
  sort: {
    display: 'flex',
    flexDirection: 'column',
    '& > button:first-child': {
      marginBottom: '1px',
    },
  },
  sortButton: {
    width: '10px',
    height: '6px',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    overflow: 'hidden',
    marginLeft: '8px',
  },
  sortIcon: {
    // marginTop: '-9px',
  },
  tooltipIcon: {
    fontSize: '16px',
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
})

const HeaderContent = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`

class TableHeaderItem extends React.PureComponent {
  onSort() {
    const { sortOrder, isSortable, onSortChange } = this.props
    let newSortOrder = SORT_TYPE.UP
    if (sortOrder === SORT_TYPE.UP) {
      newSortOrder = SORT_TYPE.DOWN
    }
    if (sortOrder === SORT_TYPE.DOWN) {
      newSortOrder = SORT_TYPE.UP
    }
    if (isSortable) {
      onSortChange(newSortOrder)
    }
  }

  render() {
    const {
      isRequired,
      isShowRequire,
      text,
      data,
      checkbox,
      isSortable,
      loading,
      classes,
      className,
      style,
      isRightAlign,
      isFullWidth,
      tooltip,
      sortOrder,
      ...rest
    } = this.props
    return (
      <th
        className={cn(
          {
            'align-right': isRightAlign,
            'full-width': isFullWidth,
          },
          classes.th,
          className,
          isSortable && classes['sortable-header']
        )}
        style={style}
        onClick={() => this.onSort()}
        aria-label="Sort"
        {...rest}
      >
        <HeaderContent style={style}>
          <Text component="label" className={cn(isSortable && classes['sortable-header'])}>
            {text && text}
            {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
            {checkbox && checkbox(data, loading)}
            {isRequired && isShowRequire && <span className={classes.required}>*</span>}
          </Text>
          {tooltip && (
            <Tooltip content={tooltip} placement="right">
              <Info className={classes.tooltipIcon} />
            </Tooltip>
          )}
          {isSortable && (
            <div className={classes.sort}>
              {(sortOrder === SORT_TYPE.DEFAULT || sortOrder === SORT_TYPE.UP) && (
                <ButtonBase title="Sort Ascending" className={classes.sortButton}>
                  <ArrowDropUp className={classes.sortIcon} />
                </ButtonBase>
              )}
              {(sortOrder === SORT_TYPE.DEFAULT || sortOrder === SORT_TYPE.DOWN) && (
                <ButtonBase title="Sort Descending" className={classes.sortButton}>
                  <ArrowDropDown className={classes.sortIcon} />
                </ButtonBase>
              )}
            </div>
          )}
        </HeaderContent>
      </th>
    )
  }
}

TableHeaderItem.defaultProps = {
  onSortChange: () => {},
  data: [],
  isShowRequire: false,
}

export default withStyles(styles)(TableHeaderItem)
